module.exports = __webpack_public_path__ + "static/img/circle-x.bf80fa55.svg";